// ─── VARIANT URL OBSERVER ─────────────────────────────────────────────────────
(function() {
  if (window.variantObserverInitialized) return;
  window.variantObserverInitialized = true;

  function updateAllVariantSections() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');

    const measurementBlocks = document.querySelectorAll('.measurement--collapsible');
    let hasMatchingMeasurementBlock = false;

    // First pass: hide all, detect matches
    measurementBlocks.forEach(block => {
      const blockVariantId = block.getAttribute('data-variant-id');
      const isDefault = block.getAttribute('data-default') === 'true';

      block.style.display = 'none';
      block.classList.remove('measurement--active');

      const details = block.querySelector('details');
      if (details && details.open) details.open = false;

      if (urlVariantId && blockVariantId === urlVariantId) {
        hasMatchingMeasurementBlock = true;
      }
    });

    // Second pass: show correct block
    measurementBlocks.forEach(block => {
      const blockVariantId = block.getAttribute('data-variant-id');
      const isDefault = block.getAttribute('data-default') === 'true';

      if (urlVariantId && blockVariantId === urlVariantId) {
        block.style.display = 'block';
        block.classList.add('measurement--active');
      } else if (!urlVariantId && isDefault) {
        block.style.display = 'block';
        block.classList.add('measurement--active');
      } else if (urlVariantId && !hasMatchingMeasurementBlock && isDefault) {
        block.style.display = 'block';
        block.classList.add('measurement--active');
      }
    });

    window.dispatchEvent(new CustomEvent('sectionsUpdated', {
      detail: { variantId: urlVariantId }
    }));
  }

  document.addEventListener('DOMContentLoaded', updateAllVariantSections);
  window.addEventListener('popstate', updateAllVariantSections);

  let currentURL = window.location.href;
  setInterval(() => {
    if (window.location.href !== currentURL) {
      currentURL = window.location.href;
      updateAllVariantSections();
    }
  }, 100);

})();


// ─── GALLERY LOAD MORE / SHOW LESS ────────────────────────────────────────────
// (function() {
//   const INITIAL_COUNT = 6;
//   let expanded = false;
//   let buttonListenerAttached = false;

//   function applyGalleryState() {
//     const gallery = document.querySelector('.product__media-list');
//     const btn = document.querySelector('.view-more-btn');
//     if (!gallery || !btn) return;

//     // Mobile: show all, hide button
//     if (window.innerWidth <= 749) {
//       gallery.querySelectorAll('.product__media-item').forEach(s => {
//         s.style.display = '';
//         s.removeAttribute('hidden');
//       });
//       btn.style.display = 'none';
//       return;
//     }

//     const slides = [...gallery.querySelectorAll('.product__media-item:not(.item-hidden)')];

//     slides.forEach((slide, index) => {
//       const hide = !expanded && index >= INITIAL_COUNT;
//       slide.style.display = hide ? 'none' : '';
//       hide ? slide.setAttribute('hidden', '') : slide.removeAttribute('hidden');
//     });

//     btn.style.display = slides.length <= INITIAL_COUNT ? 'none' : '';
//     btn.classList.toggle('expanded', expanded);
//   }

//   function attachButtonListener() {
//     if (buttonListenerAttached) return;
//     const btn = document.querySelector('.view-more-btn');
//     if (!btn) return;

//     btn.addEventListener('click', function() {
//       expanded = !expanded;
//       applyGalleryState();
//     });

//     buttonListenerAttached = true;
//   }

//   function init() {
//     expanded = false;
//     attachButtonListener();
//     applyGalleryState();
//   }

//   // Wait for button to exist in DOM
//   function waitForButton() {
//     const btn = document.querySelector('.view-more-btn');
//     if (btn) {
//       init();
//       return;
//     }
//     const observer = new MutationObserver(() => {
//       if (document.querySelector('.view-more-btn')) {
//         observer.disconnect();
//         init();
//       }
//     });
//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   // Listen for variant change via Dawn's pubsub OR URL change fallback
//   function waitForPubSub() {
//     if (window.subscribe && window.PUB_SUB_EVENTS) {
//       window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
//         expanded = false;
//         setTimeout(applyGalleryState, 200);
//       });
//       return;
//     }
//     setTimeout(waitForPubSub, 100);
//   }

//   // Fallback: watch URL for variant changes
//   let lastVariant = new URLSearchParams(window.location.search).get('variant');
//   setInterval(() => {
//     const currentVariant = new URLSearchParams(window.location.search).get('variant');
//     if (currentVariant !== lastVariant) {
//       lastVariant = currentVariant;
//       expanded = false;
//       setTimeout(applyGalleryState, 200);
//     }
//   }, 150);

//   waitForButton();
//   waitForPubSub();

// })();

(function() {
  const INITIAL_COUNT = 6;
  let expanded = false;
  let buttonListenerAttached = false;
  let resizeTimer;

  function isMobile() {
    return window.innerWidth <= 749;
  }

  function syncDots(gallery) {
    const dotsContainer = document.querySelector('.dots');
    if (!dotsContainer || !gallery) return;

    const allSlides = [...gallery.querySelectorAll('.product__media-item:not(.item-hidden)')];
    const targetCount = allSlides.length;
    let dots = [...dotsContainer.querySelectorAll('.dot')];

    if (dots.length === targetCount) return;

    // Add missing dots
    for (let i = dots.length; i < targetCount; i++) {
      const dot = document.createElement('div');
      dot.className = 'dot';
      dot.dataset.index = i;
      dot.tabIndex = 0;
      dot.setAttribute('role', 'button');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dotsContainer.appendChild(dot);
    }

    // Remove extra dots
    dots = [...dotsContainer.querySelectorAll('.dot')];
    while (dots.length > targetCount) {
      dots[dots.length - 1].remove();
      dots = [...dotsContainer.querySelectorAll('.dot')];
    }
  }

  function applyGalleryState() {
    const gallery = document.querySelector('.product__media-list');
    const btn = document.querySelector('.view-more-btn');
    if (!gallery || !btn) return;

    if (isMobile()) {
      gallery.querySelectorAll('.product__media-item').forEach(s => {
        s.style.display = 'block';
        s.removeAttribute('hidden');
      });
      btn.style.display = 'none';
      // Delay so slides are fully visible before counting dots
      setTimeout(() => syncDots(gallery), 50);
      setTimeout(() => syncDots(gallery), 200);
      return;
    }

    const slides = [...gallery.querySelectorAll('.product__media-item:not(.item-hidden)')];
    slides.forEach((slide, index) => {
      const hide = !expanded && index >= INITIAL_COUNT;
      slide.style.display = hide ? 'none' : '';
      hide ? slide.setAttribute('hidden', '') : slide.removeAttribute('hidden');
    });

    btn.style.display = slides.length <= INITIAL_COUNT ? 'none' : '';
    btn.classList.toggle('expanded', expanded);
  }

  function attachButtonListener() {
    if (buttonListenerAttached) return;
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.view-more-btn');
      if (!btn) return;
      if (isMobile()) return;
      expanded = !expanded;
      applyGalleryState();
    });
    buttonListenerAttached = true;
  }

  function init() {
    expanded = false;
    attachButtonListener();
    applyGalleryState();
    setTimeout(applyGalleryState, 300);
    setTimeout(applyGalleryState, 700);

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyGalleryState, 100);
    });
  }

  function waitForButton() {
    const btn = document.querySelector('.view-more-btn');
    if (btn) {
      init();
      return;
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector('.view-more-btn')) {
        observer.disconnect();
        init();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function waitForPubSub() {
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
        expanded = false;
        setTimeout(applyGalleryState, 200);
      });
      return;
    }
    setTimeout(waitForPubSub, 100);
  }

  let lastVariant = new URLSearchParams(window.location.search).get('variant');
  setInterval(() => {
    const currentVariant = new URLSearchParams(window.location.search).get('variant');
    if (currentVariant !== lastVariant) {
      lastVariant = currentVariant;
      expanded = false;
      setTimeout(applyGalleryState, 200);
    }
  }, 150);

  waitForButton();
  waitForPubSub();


  document.addEventListener('page:updated', function() {
    expanded = false;
    setTimeout(applyGalleryState, 100);
  });

})();